console.log("BYZA Bundle script running");

function enhanceByzaDropdowns() {
  if (typeof window.productInspiredByMap !== 'object') return;

  document.querySelectorAll('select').forEach(select => {
    select.querySelectorAll('option').forEach(option => {
      const originalText = option.textContent;
      const cleaned = originalText.split(' - ')[0].split(' – ')[0].trim();

      const matchKey = Object.keys(window.productInspiredByMap).find(name =>
        originalText.toLowerCase().includes(name.toLowerCase())
      );
      const inspired = window.productInspiredByMap[matchKey];

      if (inspired && !option.textContent.includes(inspired)) {
        option.textContent = `${cleaned} (${inspired})`;
      }
    });
  });
}

function injectByzaHeaders() {
  document.querySelectorAll('select').forEach(select => {
    const alreadyWrapped = select.closest('.byza-dropdown-wrapper');
    if (alreadyWrapped) return;

    const label = select.previousElementSibling;
    let labelText = label && label.tagName === 'LABEL' ? label.textContent.trim() : 'Fragrance';

    if (label && label.tagName === 'LABEL') label.remove();

    const wrapper = document.createElement('div');
    wrapper.className = 'byza-dropdown-wrapper';

    const header = document.createElement('div');
    header.className = 'byza-header';
    header.textContent = `${labelText} (Inspired by)`;

    const parent = select.parentElement;
    parent.insertBefore(wrapper, select);
    wrapper.appendChild(header);
    wrapper.appendChild(select);
  });
}

function applyAllEnhancements() {
  enhanceByzaDropdowns();
  injectByzaHeaders();
}

const observer = new MutationObserver(applyAllEnhancements);

document.addEventListener('DOMContentLoaded', () => {
  observer.observe(document.body, { childList: true, subtree: true });
  applyAllEnhancements();
});
